import { FloatingOverlay, useMergeRefs, useTransitionStyles, FloatingPortal, FloatingFocusManager, useFloating, useDismiss, useRole, useInteractions, offset, flip, shift, size, autoUpdate, arrow, useHover, safePolygon, useFocus } from '@floating-ui/react';
export { FloatingPortal, useMergeRefs } from '@floating-ui/react';
import React, { forwardRef, useRef, useState, useEffect, useCallback } from 'react';
import { baseContainer, useBoundingClientRect, baseStyling, baseFlexbox, useId, Skeleton, Heading, Icon, partitionComponents, isComponent, IconButton, Flexbox, Text, RedsiftTypographyFontWeightSemiBold, Spinner, NotificationsColorPalette } from '@redsift/design-system';
import classNames from 'classnames';
import { mdiClose, mdiAlert, mdiCheckCircle, mdiAlertCircle, mdiInformation } from '@redsift/icons';
import { useLocalizedStringFormatter } from '@react-aria/i18n';
import styled, { css } from 'styled-components';
import { ToastContainer as ToastContainer$1, Slide, toast } from 'react-toastify';

const DialogContext = /*#__PURE__*/React.createContext(null);

/**
 * Context props.
 */

/**
 * Component variant.
 */
const DialogSize = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge'
};

/**
 * Component props.
 */

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var close$3 = "Close";
var enUS$1 = {
	close: close$3
};

var close$2 = "Fermer";
var frFR$1 = {
	close: close$2
};

var intlMessages$1 = {
  'en-US': enUS$1,
  'fr-FR': frFR$1
};

/**
 * Component style.
 */
const StyledDialogContent = styled.div`
  background-color: var(--redsift-color-neutral-white);
  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  color: var(--redsift-color-neutral-black);
  display: flex;
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  flex-direction: column;
  font-family: var(--redsift-typography-dialog-font-family);
  font-size: var(--redsift-typography-dialog-font-size);
  font-weight: var(--redsift-typography-dialog-font-weight);
  line-height: var(--redsift-typography-dialog-line-height);
  margin: 32px;
  max-width: calc(100vw - 48px);
  padding: 24px;
  width: 540px;
  z-index: var(--redsift-layout-z-index-dialog);

  ${_ref => {
  let {
    $width
  } = _ref;
  return css`
    width: ${$width};
  `;
}}

  &:focus-visible {
    outline: none;
  }

  .redsift-dialog-content__header {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
  }

  .redsift-card-header__icon-button {
    margin-top: 8px;
    margin-left: auto;
    margin-right: 8px;

    [dir='rtl'] & {
      margin-left: 8px;
      margin-right: auto;
    }
  }
`;
const StyledFloatingOverlay = styled(FloatingOverlay)`
  background: rgba(0, 0, 0, 0.8);
  display: grid;
  place-items: center;
  z-index: var(--redsift-layout-z-index-overlay);
`;

/**
 * Component style.
 */
const StyledDialogContentActions = styled.div`
  display: flex;
  ${baseContainer}

  margin-top: 8px;
  margin-bottom: 8px;

  &:focus-visible {
    outline: none;
  }
`;

const _excluded$7 = ["children", "className"];
const COMPONENT_NAME$d = 'DialogContentActions';
const CLASSNAME$d = 'redsift-dialog-content-actions';
const DEFAULT_PROPS$d = {
  flexDirection: 'row'
};

/**
 * The DialogContentActions component.
 */
const DialogContentActions = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      className
    } = props,
    forwardedProps = _objectWithoutProperties(props, _excluded$7);
  const {
    actionsRef,
    initialFocus
  } = useDialogContext();
  return /*#__PURE__*/React.createElement(StyledDialogContentActions, _extends({}, forwardedProps, {
    className: classNames(DialogContentActions.className, className),
    ref: useMergeRefs([ref, actionsRef]),
    tabIndex: initialFocus === 'actions' ? -1 : undefined
  }), children);
});
DialogContentActions.className = CLASSNAME$d;
DialogContentActions.defaultProps = DEFAULT_PROPS$d;
DialogContentActions.displayName = COMPONENT_NAME$d;

/**
 * Component style.
 */
const StyledDialogContentBody = styled.div`
  ${baseContainer}

  overflow-y: auto;
  ${_ref => {
  let {
    $marginTop,
    $marginBottom
  } = _ref;
  return css`
    max-height: calc(100vh - ${$marginTop + $marginBottom}px);
  `;
}}

  color: var(--redsift-color-neutral-darkgrey);
  font-family: var(--redsift-typography-body-font-family);
  font-size: var(--redsift-typography-body-font-size);
  font-weight: var(--redsift-typography-body-font-weight);
  line-height: var(--redsift-typography-body-line-height);
  padding: 0 24px;
  margin: 16px -24px;

  &:focus-visible {
    outline: none;
  }

  scrollbar-color: var(--redsift-color-neutral-midgrey) transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    block-size: 9px;
    inline-size: 9px;
  }

  &::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: var(--redsift-color-neutral-midgrey);
    border-radius: 0px;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb:horizontal,
  &::-webkit-scrollbar-thumb:vertical {
    &:hover {
      background-color: var(--redsift-color-neutral-darkgrey);
    }
  }

  &::-webkit-scrollbar-corner {
    visibility: hidden;
  }
`;

const _excluded$6 = ["children", "className"];
const COMPONENT_NAME$c = 'DialogContentBody';
const CLASSNAME$c = 'redsift-dialog-content-body';
const DEFAULT_PROPS$c = {};

/**
 * The DialogContentBody component.
 */
const DialogContentBody = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      className
    } = props,
    forwardedProps = _objectWithoutProperties(props, _excluded$6);
  const {
    actionsRef,
    bodyRef,
    hasCloseButton,
    headerRef,
    initialFocus
  } = useDialogContext();
  const {
    height: headerHeight = 0
  } = useBoundingClientRect(headerRef, [children, headerRef]);
  const {
    height: actionsHeight = 0
  } = useBoundingClientRect(actionsRef, [children, actionsRef]);

  /* istanbul ignore next */
  return /*#__PURE__*/React.createElement(StyledDialogContentBody, _extends({}, forwardedProps, {
    className: classNames(DialogContentBody.className, className),
    ref: useMergeRefs([ref, bodyRef]),
    tabIndex: initialFocus === 'body' ? -1 : undefined,
    $marginTop: Math.max(headerHeight, hasCloseButton ? 40 : 0) + 80,
    $marginBottom: (actionsHeight === 0 ? 0 : actionsHeight + 16) + 80
  }), children);
});
DialogContentBody.className = CLASSNAME$c;
DialogContentBody.defaultProps = DEFAULT_PROPS$c;
DialogContentBody.displayName = COMPONENT_NAME$c;

/**
 * Component style.
 */
const StyledDialogContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${baseStyling}
  ${baseFlexbox}

  color: var(--redsift-color-neutral-black);

  .redsift-dialog-content-header__header {
    align-items: center;
    display: flex;
    gap: 8px;
    padding: 10px 0px;
    margin: 0px;
  }

  .redsift-dialog-content-header__subheader {
    font-family: var(--redsift-typography-body-font-family);
    font-size: var(--redsift-typography-body-font-size);
    font-weight: var(--redsift-typography-body-font-weight);
    line-height: var(--redsift-typography-body-line-height);
  }
`;

const _excluded$5 = ["children", "className", "header", "headingProps", "icon", "iconProps", "isLoading", "subheader"];
const COMPONENT_NAME$b = 'DialogContentHeader';
const CLASSNAME$b = 'redsift-dialog-content-header';
const DEFAULT_PROPS$b = {};

/**
 * The DialogContentHeader component.
 */
const DialogContentHeader = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      className,
      header,
      headingProps,
      icon,
      iconProps,
      isLoading,
      subheader
    } = props,
    forwardedProps = _objectWithoutProperties(props, _excluded$5);
  const {
    setLabelId,
    setDescriptionId,
    headerRef,
    initialFocus
  } = useDialogContext();
  const [labelId] = useId();
  const [descriptionId] = useId();

  // Only sets `aria-labelledby` on the Dialog root element
  // if this component is mounted inside it.
  React.useLayoutEffect(() => {
    setLabelId(labelId);
    return () => setLabelId(undefined);
  }, [labelId, setLabelId]);

  // Only sets `aria-describedby` on the Dialog root element
  // if this component is mounted inside it.
  React.useLayoutEffect(() => {
    setDescriptionId(descriptionId);
    return () => setDescriptionId(undefined);
  }, [descriptionId, setDescriptionId]);
  return /*#__PURE__*/React.createElement(StyledDialogContentHeader, _extends({}, forwardedProps, {
    className: classNames(DialogContentHeader.className, className),
    ref: useMergeRefs([ref, headerRef]),
    tabIndex: initialFocus === 'header' ? -1 : undefined
  }), subheader ? /*#__PURE__*/React.createElement(Skeleton.Text, {
    variant: "body",
    isLoaded: !isLoading
  }, /*#__PURE__*/React.createElement("div", {
    className: `${DialogContentHeader.className}__subheader`
  }, subheader)) : null, header ? /*#__PURE__*/React.createElement(Skeleton.Text, {
    variant: (headingProps === null || headingProps === void 0 ? void 0 : headingProps.variant) || 'h2',
    isLoaded: !isLoading,
    marginTop: "10px",
    marginBottom: "10px"
  }, /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h2",
    color: "black",
    className: `${DialogContentHeader.className}__header`,
    variant: "h2"
  }, headingProps), icon ? /*#__PURE__*/React.createElement(Icon, _extends({
    icon: icon,
    "aria-hidden": "true",
    size: "large"
  }, iconProps)) : null, header)) : null, children ? /*#__PURE__*/React.createElement("div", {
    id: descriptionId
  }, children) : null);
});
DialogContentHeader.className = CLASSNAME$b;
DialogContentHeader.defaultProps = DEFAULT_PROPS$b;
DialogContentHeader.displayName = COMPONENT_NAME$b;

const _excluded$4 = ["children", "className"];
const COMPONENT_NAME$a = 'DialogContent';
const CLASSNAME$a = 'redsift-dialog-content';
const DEFAULT_PROPS$a = {};
const sizeToDimension = size => {
  if (typeof size !== 'string') {
    return size;
  }
  switch (size) {
    case DialogSize.small:
      return {
        width: '540px'
      };
    case DialogSize.large:
      return {
        width: '800px'
      };
    case DialogSize.xlarge:
      return {
        width: '80vw'
      };
    case DialogSize.medium:
    default:
      return {
        width: '700px'
      };
  }
};

/**
 * The DialogContent component.
 */
const BaseDialogContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      className
    } = props,
    forwardedProps = _objectWithoutProperties(props, _excluded$4);
  const {
    context: floatingContext,
    getFloatingProps,
    refs,
    labelId,
    descriptionId,
    handleOpen,
    hasCloseButton,
    initialFocus: propsInitialFocus,
    size,
    headerRef,
    bodyRef,
    actionsRef
  } = useDialogContext();
  const {
    isMounted,
    styles
  } = useTransitionStyles(floatingContext);
  const dialogRef = useMergeRefs([refs.setFloating, ref]);
  const {
    width
  } = sizeToDimension(size);
  const stringFormatter = useLocalizedStringFormatter(intlMessages$1);
  const [[header], [body], [actions]] = partitionComponents(React.Children.toArray(children), [isComponent('DialogContentHeader'), isComponent('DialogContentBody'), isComponent('DialogContentActions')]);
  const initialFocus = propsInitialFocus === 'header' ? headerRef : propsInitialFocus === 'body' ? bodyRef : propsInitialFocus === 'actions' ? actionsRef : propsInitialFocus ? propsInitialFocus : undefined;
  return /*#__PURE__*/React.createElement(FloatingPortal, {
    id: "redsift-app-container"
  }, isMounted && /*#__PURE__*/React.createElement(StyledFloatingOverlay, {
    lockScroll: true,
    style: styles
  }, /*#__PURE__*/React.createElement(FloatingFocusManager, {
    context: floatingContext,
    initialFocus: initialFocus ? initialFocus : undefined
  }, /*#__PURE__*/React.createElement(StyledDialogContent, _extends({
    className: classNames(DialogContent.className, className)
  }, forwardedProps, {
    ref: dialogRef,
    "aria-labelledby": labelId,
    "aria-describedby": descriptionId
  }, getFloatingProps(props), {
    style: styles,
    $width: width
  }), header || hasCloseButton ? /*#__PURE__*/React.createElement("div", {
    className: `${BaseDialogContent.className}__header`
  }, header, hasCloseButton ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": stringFormatter.format('close'),
    className: `${BaseDialogContent.className}-header__icon-button`,
    color: "question",
    icon: mdiClose,
    onClick: () => handleOpen(false)
  }) : null) : null, body || actions ? /*#__PURE__*/React.createElement("div", {
    className: `${BaseDialogContent.className}__content`
  }, body, actions) : null))));
});
BaseDialogContent.className = CLASSNAME$a;
BaseDialogContent.defaultProps = DEFAULT_PROPS$a;
BaseDialogContent.displayName = COMPONENT_NAME$a;
const DialogContent = Object.assign(BaseDialogContent, {
  Header: DialogContentHeader,
  Body: DialogContentBody,
  Actions: DialogContentActions
});

const COMPONENT_NAME$9 = 'DialogTrigger';
const CLASSNAME$9 = 'redsift-dialog-trigger';
const DEFAULT_PROPS$9 = {};

/**
 * The DialogTrigger component.
 */
const DialogTrigger = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children
  } = props;
  const {
    getReferenceProps,
    isOpen,
    handleOpen,
    refs
  } = useDialogContext();
  const childrenRef = children.ref;
  const triggerRef = useMergeRefs([refs.setReference, ref, childrenRef]);
  if (isComponent('Button')(children) || isComponent('IconButton')(children) || isComponent('LinkButton')(children) || isComponent('Checkbox')(children)) {
    var _children$props$child;
    return /*#__PURE__*/React.cloneElement(children, _objectSpread2(_objectSpread2({}, getReferenceProps(_objectSpread2(_objectSpread2(_objectSpread2({
      ref: triggerRef
    }, props), children.props), {}, {
      children: (_children$props$child = children.props.children) !== null && _children$props$child !== void 0 ? _children$props$child : ''
    }))), {}, {
      onClick: () => handleOpen(!isOpen),
      isActive: isOpen
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
});
DialogTrigger.className = CLASSNAME$9;
DialogTrigger.defaultProps = DEFAULT_PROPS$9;
DialogTrigger.displayName = COMPONENT_NAME$9;

function useDialog(_ref) {
  let {
    defaultOpen,
    hasCloseButton,
    initialFocus,
    isOpen: propsIsOpen,
    onOpen,
    size
  } = _ref;
  const headerRef = useRef(null);
  const bodyRef = useRef(null);
  const actionsRef = useRef(null);
  const [labelId, setLabelId] = React.useState();
  const [descriptionId, setDescriptionId] = React.useState();
  const [isOpen, setIsOpen] = useState(propsIsOpen !== null && propsIsOpen !== void 0 ? propsIsOpen : defaultOpen);
  useEffect(() => {
    setIsOpen(propsIsOpen !== null && propsIsOpen !== void 0 ? propsIsOpen : defaultOpen);
  }, [propsIsOpen, defaultOpen]);
  const handleOpen = useCallback(collapsed => {
    if (onOpen) {
      onOpen(collapsed);
    }
    if (propsIsOpen === undefined || propsIsOpen === null) {
      setIsOpen(collapsed);
    }
  }, [onOpen]);
  const data = useFloating({
    open: isOpen,
    onOpenChange: handleOpen
  });
  const context = data.context;
  const dismiss = useDismiss(context, {
    outsidePressEvent: 'mousedown'
  });
  const role = useRole(context);
  const interactions = useInteractions([dismiss, role]);
  return React.useMemo(() => _objectSpread2(_objectSpread2(_objectSpread2({
    isOpen,
    handleOpen
  }, interactions), data), {}, {
    labelId,
    descriptionId,
    setLabelId,
    setDescriptionId,
    hasCloseButton,
    initialFocus,
    size,
    headerRef,
    bodyRef,
    actionsRef
  }), [isOpen, handleOpen, interactions, data, labelId, descriptionId, hasCloseButton, initialFocus, size, headerRef, bodyRef, actionsRef]);
}

const COMPONENT_NAME$8 = 'Dialog';
const CLASSNAME$8 = 'redsift-dialog';
const DEFAULT_PROPS$8 = {
  hasCloseButton: true,
  size: DialogSize.medium
};

/**
 * The Dialog component.
 */
const BaseDialog = props => {
  const {
    children,
    defaultOpen,
    hasCloseButton = DEFAULT_PROPS$8.hasCloseButton,
    initialFocus,
    isOpen,
    onOpen,
    size
  } = props;
  const dialog = useDialog({
    defaultOpen,
    hasCloseButton,
    initialFocus,
    isOpen,
    onOpen,
    size
  });
  const [[trigger], [content]] = partitionComponents(React.Children.toArray(children), [isComponent('DialogTrigger'), isComponent('DialogContent')]);
  return /*#__PURE__*/React.createElement(DialogContext.Provider, {
    value: dialog
  }, trigger, content);
};
BaseDialog.className = CLASSNAME$8;
BaseDialog.defaultProps = DEFAULT_PROPS$8;
BaseDialog.displayName = COMPONENT_NAME$8;
const Dialog = Object.assign(BaseDialog, {
  Trigger: DialogTrigger,
  Content: DialogContent
});

const useDialogContext = () => {
  const context = React.useContext(DialogContext);
  if (context == null) {
    throw new Error('Dialog components must be wrapped in <Dialog />');
  }
  return context;
};

const PopoverContext = /*#__PURE__*/React.createContext(null);

/**
 * Context props.
 */

/**
 * Component variant.
 */
const PopoverPlacement = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
  'top-start': 'top-start',
  'top-end': 'top-end',
  'right-start': 'right-start',
  'right-end': 'right-end',
  'bottom-start': 'bottom-start',
  'bottom-end': 'bottom-end',
  'left-start': 'left-start',
  'left-end': 'left-end'
};

/**
 * Component props.
 */

/**
 * Component style.
 */
const StyledPopoverContent = styled.div`
  ${_ref => {
  let {
    display
  } = _ref;
  return display ? `display: ${display};` : 'display: flex;';
}}
  font-family: var(--redsift-typography-body-font-family);
  font-size: var(--redsift-typography-body-font-size);
  font-weight: var(--redsift-typography-body-font-weight);
  line-height: 20px;
  color: var(--redsift-color-neutral-black);

  ${_ref2 => {
  let {
    padding,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop
  } = _ref2;
  return css`
      ${padding ? `padding: ${padding};` : ''}
      ${paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}
      ${paddingLeft ? `padding-left: ${paddingLeft};` : ''}
      ${paddingRight ? `padding-right: ${paddingRight};` : ''}
      ${paddingTop ? `padding-top: ${paddingTop};` : ''}
    `;
}}
  ${_ref3 => {
  let {
    margin,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop
  } = _ref3;
  return css`
      ${margin ? `margin: ${margin};` : ''}
      ${marginBottom ? `margin-bottom: ${marginBottom};` : ''}
        ${marginLeft ? `margin-left: ${marginLeft};` : ''}
        ${marginRight ? `margin-right: ${marginRight};` : ''}
        ${marginTop ? `margin-top: ${marginTop};` : ''}
    `;
}}
  ${_ref4 => {
  let {
    height,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    width
  } = _ref4;
  return css`
      ${height !== undefined ? `height: ${typeof height === 'number' ? `${height}px` : height};` : ''}
      ${maxHeight ? `max-height: ${maxHeight};` : ''}
          ${maxWidth ? `max-width: ${maxWidth};` : ''}
          ${minHeight ? `min-height: ${minHeight};` : ''}
          ${minWidth ? `min-width: ${minWidth};` : ''}
          ${width !== undefined ? `width: ${typeof width === 'number' ? `${width}px` : width};` : ''}
    `;
}}
  ${_ref5 => {
  let {
    position,
    top,
    bottom,
    left,
    right,
    zIndex
  } = _ref5;
  return css`
      ${position ? `position: ${position};` : ''}
      ${top ? `top: ${top};` : ''}
            ${bottom ? `bottom: ${bottom};` : ''}
            ${left ? `left: ${left};` : ''}
            ${right ? `right: ${right};` : ''}
            ${zIndex ? `z-index: ${zIndex};` : ''}
    `;
}}
  ${_ref6 => {
  let {
    alignContent,
    alignItems,
    gap,
    gridAutoColumns,
    gridAutoRows,
    gridTemplateAreas,
    gridTemplateColumns,
    gridTemplateRows,
    justifyContent,
    justifyItems
  } = _ref6;
  return css`
      ${alignContent ? `align-content: ${alignContent};` : ''}
      ${alignItems ? `align-items: ${alignItems};` : ''}
              ${gap ? `gap: ${gap};` : ''}
              ${gridAutoColumns ? `grid-auto-columns: ${gridAutoColumns};` : ''}
              ${gridAutoRows ? `grid-auto-rows: ${gridAutoRows};` : ''}
              ${gridTemplateAreas ? `grid-template-areas: ${gridTemplateAreas};` : ''}
              ${gridTemplateColumns ? `grid-template-columns: ${gridTemplateColumns};` : ''}
              ${gridTemplateRows ? `grid-template-rows: ${gridTemplateRows};` : ''}
              ${justifyContent ? `justify-content: ${justifyContent};` : ''}
              ${justifyItems ? `justify-items: ${justifyItems};` : ''}
    `;
}}
  ${_ref7 => {
  let {
    alignContent,
    alignItems,
    flexDirection,
    flexWrap,
    gap,
    justifyContent
  } = _ref7;
  return css`
      ${alignContent ? `align-content: ${alignContent};` : ''}
      ${alignItems ? `align-items: ${alignItems};` : ''}
      ${flexDirection ? `flex-direction: ${flexDirection};` : ''}
      ${flexWrap ? `flex-wrap: ${flexWrap};` : ''}
      gap: ${gap};
      ${justifyContent ? `justify-content: ${justifyContent};` : ''}
    `;
}}

  background-color: var(--redsift-color-neutral-white);
  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  color: var(--redsift-color-neutral-black);
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  max-width: calc(100vw - 48px);
  z-index: var(--redsift-layout-z-index-popover);
  overflow: auto;

  &:focus-visible {
    outline: none;
  }
`;

const _excluded$3 = ["children", "className", "style"];
const COMPONENT_NAME$7 = 'PopoverContent';
const CLASSNAME$7 = 'redsift-popover-content';
const DEFAULT_PROPS$7 = {};

/**
 * The PopoverContent component.
 */
const PopoverContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      className,
      style
    } = props,
    forwardedProps = _objectWithoutProperties(props, _excluded$3);
  const {
    context: floatingContext,
    getFloatingProps,
    isModal,
    isOpen,
    refs,
    strategy,
    x,
    y
  } = usePopoverContext();
  const popoverRef = useMergeRefs([refs.setFloating, ref]);
  return /*#__PURE__*/React.createElement(FloatingPortal, {
    id: "redsift-app-container"
  }, isOpen && /*#__PURE__*/React.createElement(FloatingFocusManager, {
    context: floatingContext,
    modal: isModal
  }, /*#__PURE__*/React.createElement(StyledPopoverContent, _extends({
    style: _objectSpread2({
      position: strategy,
      top: y !== null && y !== void 0 ? y : 0,
      left: x !== null && x !== void 0 ? x : 0,
      width: 'fit-content'
    }, style)
  }, getFloatingProps(props), {
    className: classNames(PopoverContent.className, className)
  }, forwardedProps, {
    ref: popoverRef
  }), children)));
});
PopoverContent.className = CLASSNAME$7;
PopoverContent.defaultProps = DEFAULT_PROPS$7;
PopoverContent.displayName = COMPONENT_NAME$7;

const COMPONENT_NAME$6 = 'PopoverTrigger';
const CLASSNAME$6 = 'redsift-popover-trigger';
const DEFAULT_PROPS$6 = {};

/**
 * The PopoverTrigger component.
 */
const PopoverTrigger = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children
  } = props;
  const {
    getReferenceProps,
    isOpen,
    handleOpen,
    refs
  } = usePopoverContext();
  const childrenRef = children.ref;
  const triggerRef = useMergeRefs([refs.setReference, ref, childrenRef]);
  if (isComponent('Button')(children) || isComponent('IconButton')(children) || isComponent('LinkButton')(children)) {
    var _children$props$child;
    return /*#__PURE__*/React.cloneElement(children, _objectSpread2(_objectSpread2({}, getReferenceProps(_objectSpread2(_objectSpread2(_objectSpread2({
      ref: triggerRef
    }, props), children.props), {}, {
      children: (_children$props$child = children.props.children) !== null && _children$props$child !== void 0 ? _children$props$child : ''
    }))), {}, {
      onClick: () => handleOpen(!isOpen),
      isActive: isOpen
    }));
  }
  return null;
});
PopoverTrigger.className = CLASSNAME$6;
PopoverTrigger.defaultProps = DEFAULT_PROPS$6;
PopoverTrigger.displayName = COMPONENT_NAME$6;

function usePopover(_ref) {
  let {
    defaultOpen,
    isModal,
    isOpen: propsIsOpen,
    maxWidth,
    minWidth,
    onOpen,
    placement,
    role: propsRole,
    width
  } = _ref;
  const [isOpen, setIsOpen] = useState(propsIsOpen !== null && propsIsOpen !== void 0 ? propsIsOpen : defaultOpen);
  useEffect(() => {
    setIsOpen(propsIsOpen !== null && propsIsOpen !== void 0 ? propsIsOpen : defaultOpen);
  }, [propsIsOpen, defaultOpen]);
  const handleOpen = useCallback(collapsed => {
    if (onOpen) {
      onOpen(collapsed);
    }
    if (propsIsOpen === undefined || propsIsOpen === null) {
      setIsOpen(collapsed);
    }
  }, [onOpen]);
  const middleware = [offset(2), flip({
    fallbackAxisSideDirection: 'end'
  }), shift({
    padding: 2
  })];
  middleware.push(size({
    apply(_ref2) {
      let {
        availableHeight,
        availableWidth,
        rects,
        elements
      } = _ref2;
      Object.assign(elements.floating.style, _objectSpread2(_objectSpread2(_objectSpread2({
        maxHeight: `${availableHeight}px`
      }, minWidth !== undefined && {
        minWidth: `${minWidth === 'available-width' ? availableWidth : minWidth === 'trigger-width' ? rects.reference.width : minWidth}px`
      }), width !== undefined && {
        width: `${width === 'available-width' ? availableWidth : width === 'trigger-width' ? rects.reference.width : width}px`
      }), maxWidth !== undefined && {
        maxWidth: `${maxWidth === 'available-width' ? availableWidth : maxWidth === 'trigger-width' ? rects.reference.width : maxWidth}px`
      }));
    }
  }));
  const data = useFloating({
    placement,
    open: isOpen,
    onOpenChange: handleOpen,
    whileElementsMounted: autoUpdate,
    middleware
  });
  const context = data.context;
  const dismiss = useDismiss(context);
  const role = useRole(context, {
    role: propsRole
  });
  const interactions = useInteractions([dismiss, role]);
  return React.useMemo(() => _objectSpread2(_objectSpread2(_objectSpread2({
    isOpen,
    handleOpen
  }, interactions), data), {}, {
    isModal
  }), [isOpen, handleOpen, interactions, data, isModal]);
}

const COMPONENT_NAME$5 = 'Popover';
const CLASSNAME$5 = 'redsift-popover';
const DEFAULT_PROPS$5 = {
  isModal: false,
  placement: PopoverPlacement.bottom,
  role: 'dialog'
};

/**
 * The Popover component.
 */
const BasePopover = props => {
  var _overrideDisplayName$, _overrideDisplayName$2;
  const {
    children,
    defaultOpen,
    isModal,
    isOpen,
    maxWidth,
    minWidth,
    onOpen,
    overrideDisplayName,
    placement,
    role,
    width
  } = props;
  const popover = usePopover({
    defaultOpen,
    isModal,
    isOpen,
    maxWidth,
    minWidth,
    onOpen,
    placement,
    role,
    width
  });
  const [[trigger], [content]] = partitionComponents(React.Children.toArray(children), [isComponent((_overrideDisplayName$ = overrideDisplayName === null || overrideDisplayName === void 0 ? void 0 : overrideDisplayName.trigger) !== null && _overrideDisplayName$ !== void 0 ? _overrideDisplayName$ : 'PopoverTrigger'), isComponent((_overrideDisplayName$2 = overrideDisplayName === null || overrideDisplayName === void 0 ? void 0 : overrideDisplayName.content) !== null && _overrideDisplayName$2 !== void 0 ? _overrideDisplayName$2 : 'PopoverContent')]);
  return /*#__PURE__*/React.createElement(PopoverContext.Provider, {
    value: popover
  }, trigger, content);
};
BasePopover.className = CLASSNAME$5;
BasePopover.defaultProps = DEFAULT_PROPS$5;
BasePopover.displayName = COMPONENT_NAME$5;
const Popover = Object.assign(BasePopover, {
  Trigger: PopoverTrigger,
  Content: PopoverContent
});

const usePopoverContext = () => {
  const context = React.useContext(PopoverContext);
  if (context == null) {
    throw new Error('Popover components must be wrapped in <Popover />');
  }
  return context;
};

/**
 * Component variant.
 */
const ToastVariant = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  loading: 'loading'
};
const ToastPlacement = {
  'top-right': 'top-right',
  'top-center': 'top-center',
  'top-left': 'top-left',
  'bottom-right': 'bottom-right',
  'bottom-center': 'bottom-center',
  'bottom-left': 'bottom-left'
};

/**
 * Component props.
 */

var close$1 = "Close";
var enUS = {
	close: close$1
};

var close = "Fermer";
var frFR = {
	close: close
};

var intlMessages = {
  'en-US': enUS,
  'fr-FR': frFR
};

/**
 * Component style.
 */
const StyledToast = styled.div`
  ${baseStyling}

  padding: 16px;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px rgb(0 0 0 / 14%), 0px 1px 10px rgb(0 0 0 / 12%);

  ${_ref => {
  let {
    $hasTitle,
    $variant
  } = _ref;
  return css`
    background-color: ${$variant === 'loading' ? 'var(--redsift-color-neutral-white)' : `var(--redsift-color-notifications-${$variant}-hover)`};

    .redsift-toast-header__icon-button {
      padding: 0px;
      .redsift-icon {
        color: var(--redsift-color-neutral-black);
      }

      &:hover,
      &:focus-visible {
        background-color: var(--redsift-color-notifications-${$variant}-active);
      }
    }

    .redsift-toast__content {
      margin-top: ${$hasTitle ? '8px' : '-24px'};
      margin-left: 38px;
    }
  `;
}}
`;

const _excluded$2 = ["children", "className", "closeToast", "closeButton", "title", "variant"];
const COMPONENT_NAME$4 = 'Toast';
const CLASSNAME$4 = 'redsift-toast';
const DEFAULT_PROPS$4 = {
  variant: 'info',
  closeButton: true
};
const getVariant = variant => {
  switch (variant) {
    case ToastVariant.info:
    default:
      return /*#__PURE__*/React.createElement(Icon, {
        icon: mdiInformation,
        color: NotificationsColorPalette.info
      });
    case ToastVariant.error:
      return /*#__PURE__*/React.createElement(Icon, {
        icon: mdiAlertCircle,
        color: NotificationsColorPalette.error
      });
    case ToastVariant.success:
      return /*#__PURE__*/React.createElement(Icon, {
        icon: mdiCheckCircle,
        color: NotificationsColorPalette.success
      });
    case ToastVariant.warning:
      return /*#__PURE__*/React.createElement(Icon, {
        icon: mdiAlert,
        color: NotificationsColorPalette.warning
      });
    case ToastVariant.loading:
      return /*#__PURE__*/React.createElement(Spinner, {
        size: "small"
      });
  }
};

/**
 * The Toast component.
 */
const Toast = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      className,
      closeToast,
      closeButton,
      title,
      variant
    } = props,
    forwardedProps = _objectWithoutProperties(props, _excluded$2);
  const stringFormatter = useLocalizedStringFormatter(intlMessages);
  const icon = getVariant(variant);
  return /*#__PURE__*/React.createElement(StyledToast, _extends({}, forwardedProps, {
    className: classNames(Toast.className, className),
    ref: ref,
    $hasTitle: Boolean(title),
    $variant: variant
  }), /*#__PURE__*/React.createElement(Flexbox, {
    className: `${Toast.className}__header`,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "space-between",
    flexDirection: "column",
    gap: "0"
  }, /*#__PURE__*/React.createElement(Flexbox, {
    className: `${Toast.className}-header__title`,
    gap: "14px",
    alignItems: "flex-start"
  }, icon, title ? /*#__PURE__*/React.createElement(Text, {
    fontWeight: RedsiftTypographyFontWeightSemiBold
  }, title) : null), children ? /*#__PURE__*/React.createElement("div", {
    className: `${Toast.className}__content`
  }, children) : null), closeButton === true ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": stringFormatter.format('close'),
    className: `${Toast.className}-header__icon-button`,
    icon: mdiClose,
    onClick: closeToast
  }) : isComponent('Button')(closeButton) || isComponent('IconButton')(closeButton) ? /*#__PURE__*/React.cloneElement(closeButton, {
    color: variant === 'loading' ? 'default' : variant,
    onClick: () => {
      var _closeButton$props$on, _closeButton$props;
      (_closeButton$props$on = (_closeButton$props = closeButton.props).onClick) === null || _closeButton$props$on === void 0 ? void 0 : _closeButton$props$on.call(_closeButton$props);
      closeToast === null || closeToast === void 0 ? void 0 : closeToast();
    }
  }) : null));
});
Toast.className = CLASSNAME$4;
Toast.defaultProps = DEFAULT_PROPS$4;
Toast.displayName = COMPONENT_NAME$4;

const ReactToastify = styled.div`
  :root {
    --toastify-color-light: #fff;
    --toastify-color-dark: #121212;
    --toastify-color-info: #3498db;
    --toastify-color-success: #07bc0c;
    --toastify-color-warning: #f1c40f;
    --toastify-color-error: #e74c3c;
    --toastify-color-transparent: rgba(255, 255, 255, 0.7);
    --toastify-icon-color-info: var(--toastify-color-info);
    --toastify-icon-color-success: var(--toastify-color-success);
    --toastify-icon-color-warning: var(--toastify-color-warning);
    --toastify-icon-color-error: var(--toastify-color-error);
    --toastify-toast-width: 320px;
    --toastify-toast-background: #fff;
    --toastify-toast-min-height: 64px;
    --toastify-toast-max-height: 800px;
    --toastify-font-family: sans-serif;
    --toastify-z-index: 9999;
    --toastify-text-color-light: #757575;
    --toastify-text-color-dark: #fff;
    --toastify-text-color-info: #fff;
    --toastify-text-color-success: #fff;
    --toastify-text-color-warning: #fff;
    --toastify-text-color-error: #fff;
    --toastify-spinner-color: #616161;
    --toastify-spinner-color-empty-area: #e0e0e0;
    --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
    --toastify-color-progress-dark: #bb86fc;
    --toastify-color-progress-info: var(--toastify-color-info);
    --toastify-color-progress-success: var(--toastify-color-success);
    --toastify-color-progress-warning: var(--toastify-color-warning);
    --toastify-color-progress-error: var(--toastify-color-error);
  }

  .Toastify__toast-container {
    z-index: var(--toastify-z-index);
    -webkit-transform: translate3d(0, 0, var(--toastify-z-index) px);
    position: fixed;
    padding: 4px;
    width: var(--toastify-toast-width);
    box-sizing: border-box;
    color: #fff;
  }
  .Toastify__toast-container--top-left {
    top: 1em;
    left: 1em;
  }
  .Toastify__toast-container--top-center {
    top: 1em;
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--top-right {
    top: 1em;
    right: 1em;
  }
  .Toastify__toast-container--bottom-left {
    bottom: 1em;
    left: 1em;
  }
  .Toastify__toast-container--bottom-center {
    bottom: 1em;
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--bottom-right {
    bottom: 1em;
    right: 1em;
  }

  @media only screen and (max-width: 480px) {
    .Toastify__toast-container {
      width: 100vw;
      padding: 0;
      left: 0;
      margin: 0;
    }
    .Toastify__toast-container--top-left,
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-right {
      top: 0;
      transform: translateX(0);
    }
    .Toastify__toast-container--bottom-left,
    .Toastify__toast-container--bottom-center,
    .Toastify__toast-container--bottom-right {
      bottom: 0;
      transform: translateX(0);
    }
    .Toastify__toast-container--rtl {
      right: 0;
      left: initial;
    }
  }
  .Toastify__toast {
    position: relative;
    min-height: var(--toastify-toast-min-height);
    box-sizing: border-box;
    margin-bottom: 1rem;
    padding: 8px;
    border-radius: 4px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    max-height: var(--toastify-toast-max-height);
    overflow: hidden;
    font-family: var(--toastify-font-family);
    cursor: default;
    direction: ltr;
    /* webkit only issue #791 */
    z-index: 0;
  }
  .Toastify__toast--rtl {
    direction: rtl;
  }
  .Toastify__toast--close-on-click {
    cursor: pointer;
  }
  .Toastify__toast-body {
    margin: auto 0;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 6px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
  .Toastify__toast-body > div:last-child {
    word-break: break-word;
    -ms-flex: 1;
    flex: 1;
  }
  .Toastify__toast-icon {
    -webkit-margin-end: 10px;
    margin-inline-end: 10px;
    width: 20px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    display: -ms-flexbox;
    display: flex;
  }

  .Toastify--animate {
    animation-fill-mode: both;
    animation-duration: 0.7s;
  }

  .Toastify--animate-icon {
    animation-fill-mode: both;
    animation-duration: 0.3s;
  }

  @media only screen and (max-width: 480px) {
    .Toastify__toast {
      margin-bottom: 0;
      border-radius: 0;
    }
  }
  .Toastify__toast-theme--dark {
    background: var(--toastify-color-dark);
    color: var(--toastify-text-color-dark);
  }
  .Toastify__toast-theme--light {
    background: var(--toastify-color-light);
    color: var(--toastify-text-color-light);
  }
  .Toastify__toast-theme--colored.Toastify__toast--default {
    background: var(--toastify-color-light);
    color: var(--toastify-text-color-light);
  }
  .Toastify__toast-theme--colored.Toastify__toast--info {
    color: var(--toastify-text-color-info);
    background: var(--toastify-color-info);
  }
  .Toastify__toast-theme--colored.Toastify__toast--success {
    color: var(--toastify-text-color-success);
    background: var(--toastify-color-success);
  }
  .Toastify__toast-theme--colored.Toastify__toast--warning {
    color: var(--toastify-text-color-warning);
    background: var(--toastify-color-warning);
  }
  .Toastify__toast-theme--colored.Toastify__toast--error {
    color: var(--toastify-text-color-error);
    background: var(--toastify-color-error);
  }

  .Toastify__progress-bar-theme--light {
    background: var(--toastify-color-progress-light);
  }
  .Toastify__progress-bar-theme--dark {
    background: var(--toastify-color-progress-dark);
  }
  .Toastify__progress-bar--info {
    background: var(--toastify-color-progress-info);
  }
  .Toastify__progress-bar--success {
    background: var(--toastify-color-progress-success);
  }
  .Toastify__progress-bar--warning {
    background: var(--toastify-color-progress-warning);
  }
  .Toastify__progress-bar--error {
    background: var(--toastify-color-progress-error);
  }
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
    background: var(--toastify-color-transparent);
  }

  .Toastify__close-button {
    color: #fff;
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    -ms-flex-item-align: start;
    align-self: flex-start;
  }
  .Toastify__close-button--light {
    color: #000;
    opacity: 0.3;
  }
  .Toastify__close-button > svg {
    fill: currentColor;
    height: 16px;
    width: 14px;
  }
  .Toastify__close-button:hover,
  .Toastify__close-button:focus {
    opacity: 1;
  }

  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }
  .Toastify__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: var(--toastify-z-index);
    opacity: 0.7;
    transform-origin: left;
  }
  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }
  .Toastify__progress-bar--controlled {
    transition: transform 0.2s;
  }
  .Toastify__progress-bar--rtl {
    right: 0;
    left: initial;
    transform-origin: right;
  }

  .Toastify__spinner {
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    border: 2px solid;
    border-radius: 100%;
    border-color: var(--toastify-spinner-color-empty-area);
    border-right-color: var(--toastify-spinner-color);
    animation: Toastify__spin 0.65s linear infinite;
  }

  @keyframes Toastify__bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }
    75% {
      transform: translate3d(10px, 0, 0);
    }
    90% {
      transform: translate3d(-5px, 0, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutRight {
    20% {
      opacity: 1;
      transform: translate3d(-20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0);
    }
  }
  @keyframes Toastify__bounceInLeft {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(-3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(25px, 0, 0);
    }
    75% {
      transform: translate3d(-10px, 0, 0);
    }
    90% {
      transform: translate3d(5px, 0, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutLeft {
    20% {
      opacity: 1;
      transform: translate3d(20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0);
    }
  }
  @keyframes Toastify__bounceInUp {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    75% {
      transform: translate3d(0, 10px, 0);
    }
    90% {
      transform: translate3d(0, -5px, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }
  }
  @keyframes Toastify__bounceInDown {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0);
    }
    75% {
      transform: translate3d(0, -10px, 0);
    }
    90% {
      transform: translate3d(0, 5px, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0);
    }
  }
  .Toastify__bounce-enter--top-left,
  .Toastify__bounce-enter--bottom-left {
    animation-name: Toastify__bounceInLeft;
  }
  .Toastify__bounce-enter--top-right,
  .Toastify__bounce-enter--bottom-right {
    animation-name: Toastify__bounceInRight;
  }
  .Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown;
  }
  .Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp;
  }

  .Toastify__bounce-exit--top-left,
  .Toastify__bounce-exit--bottom-left {
    animation-name: Toastify__bounceOutLeft;
  }
  .Toastify__bounce-exit--top-right,
  .Toastify__bounce-exit--bottom-right {
    animation-name: Toastify__bounceOutRight;
  }
  .Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp;
  }
  .Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown;
  }

  @keyframes Toastify__zoomIn {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
      opacity: 1;
    }
  }
  @keyframes Toastify__zoomOut {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    to {
      opacity: 0;
    }
  }
  .Toastify__zoom-enter {
    animation-name: Toastify__zoomIn;
  }

  .Toastify__zoom-exit {
    animation-name: Toastify__zoomOut;
  }

  @keyframes Toastify__flipIn {
    from {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0;
    }
    40% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in;
    }
    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity: 1;
    }
    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }
    to {
      transform: perspective(400px);
    }
  }
  @keyframes Toastify__flipOut {
    from {
      transform: perspective(400px);
    }
    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity: 1;
    }
    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity: 0;
    }
  }
  .Toastify__flip-enter {
    animation-name: Toastify__flipIn;
  }

  .Toastify__flip-exit {
    animation-name: Toastify__flipOut;
  }

  @keyframes Toastify__slideInRight {
    from {
      transform: translate3d(110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInLeft {
    from {
      transform: translate3d(-110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInUp {
    from {
      transform: translate3d(0, 110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInDown {
    from {
      transform: translate3d(0, -110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(110%, 0, 0);
    }
  }
  @keyframes Toastify__slideOutLeft {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(-110%, 0, 0);
    }
  }
  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, 500px, 0);
    }
  }
  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, -500px, 0);
    }
  }
  .Toastify__slide-enter--top-left,
  .Toastify__slide-enter--bottom-left {
    animation-name: Toastify__slideInLeft;
  }
  .Toastify__slide-enter--top-right,
  .Toastify__slide-enter--bottom-right {
    animation-name: Toastify__slideInRight;
  }
  .Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown;
  }
  .Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp;
  }

  .Toastify__slide-exit--top-left,
  .Toastify__slide-exit--bottom-left {
    animation-name: Toastify__slideOutLeft;
  }
  .Toastify__slide-exit--top-right,
  .Toastify__slide-exit--bottom-right {
    animation-name: Toastify__slideOutRight;
  }
  .Toastify__slide-exit--top-center {
    animation-name: Toastify__slideOutUp;
  }
  .Toastify__slide-exit--bottom-center {
    animation-name: Toastify__slideOutDown;
  }

  @keyframes Toastify__spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

/**
 * Component style.
 */
const StyledToastContainer = styled(ToastContainer$1)`
  --toastify-color-light: var(--redsift-color-notifications-neutral-white);
  --toastify-color-dark: var(--redsift-color-notifications-neutral-black);
  --toastify-color-info: var(--redsift-color-notifications-info-primary);
  --toastify-color-success: var(--redsift-color-notifications-success-primary);
  --toastify-color-warning: var(--redsift-color-notifications-warning-primary);
  --toastify-color-error: var(--redsift-color-notifications-error-primary);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);
  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);
  --toastify-toast-width: 'fit-content';
  --toastify-toast-background: var(--redsift-color-neutral-white);
  --toastify-toast-min-height: 58px;
  --toastify-toast-max-height: 800px;
  --toastify-font-family: sans-serif;
  --toastify-z-index: var(--redsift-layout-z-index-tooltip);
  --toastify-text-color-light: var(--redsift-color-neutral-black);
  --toastify-text-color-dark: var(--redsift-color-neutral-white);
  --toastify-text-color-info: var(--redsift-color-neutral-white);
  --toastify-text-color-success: var(--redsift-color-neutral-white);
  --toastify-text-color-warning: var(--redsift-color-neutral-white);
  --toastify-text-color-error: var(--redsift-color-neutral-white);
  --toastify-spinner-color: var(--redsift-color-neutral-darkgrey);
  --toastify-spinner-color-empty-area: var(--redsift-color-neutral-lightgrey);
  --toastify-color-progress-light: var(--redsift-color-neutral-darkgrey);
  --toastify-color-progress-dark: var(--redsift-color-neutral-xlightgrey);
  --toastify-color-progress-default: var(--redsift-color-ctas-primary-primary);
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);

  min-width: 350px;
  max-width: 600px;

  .Toastify__toast {
    box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px rgb(0 0 0 / 14%), 0px 1px 10px rgb(0 0 0 / 12%);
    padding: 0;
  }

  .Toastify__toast-body {
    padding: 0;
  }

  .Toastify__toast-theme--colored.Toastify__toast--default {
    background: none;
  }
  .Toastify__toast-theme--colored.Toastify__toast--info {
    background: none;
  }
  .Toastify__toast-theme--colored.Toastify__toast--success {
    background: none;
  }
  .Toastify__toast-theme--colored.Toastify__toast--warning {
    background: none;
  }
  .Toastify__toast-theme--colored.Toastify__toast--error {
    background: none;
  }

  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--default {
    background: var(--toastify-color-progress-default);
  }
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--info {
    background: var(--toastify-color-progress-info);
  }
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success {
    background: var(--toastify-color-progress-success);
  }
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {
    background: var(--toastify-color-progress-warning);
  }
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
    background: var(--toastify-color-progress-error);
  }
`;

const _excluded$1 = ["placement"];
const COMPONENT_NAME$3 = 'ToastContainer';
const CLASSNAME$3 = 'redsift-toast-container';
const DEFAULT_PROPS$3 = {
  autoClose: 5000,
  closeOnClick: false,
  draggable: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  placement: 'top-right'
};

/**
 * The ToastContainer component.
 */
const ToastContainer = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      placement
    } = props,
    forwardedProps = _objectWithoutProperties(props, _excluded$1);
  return /*#__PURE__*/React.createElement(ReactToastify, null, /*#__PURE__*/React.createElement(StyledToastContainer, _extends({}, forwardedProps, {
    className: ToastContainer.className,
    closeButton: false,
    icon: false,
    newestOnTop: placement.includes('bottom'),
    position: placement,
    ref: ref,
    theme: "colored",
    transition: Slide
  })));
});
ToastContainer.className = CLASSNAME$3;
ToastContainer.defaultProps = DEFAULT_PROPS$3;
ToastContainer.displayName = COMPONENT_NAME$3;

const _excluded = ["content", "closeButton", "placement", "title", "variant"],
  _excluded2 = ["content", "closeButton", "placement", "title", "variant"],
  _excluded3 = ["closeButton", "placement"];
const notify = (_ref, props) => {
  let {
      content,
      closeButton,
      placement,
      title,
      variant = 'info'
    } = _ref,
    options = _objectWithoutProperties(_ref, _excluded);
  return toast( /*#__PURE__*/React.createElement(Toast, _extends({
    title: title,
    variant: variant,
    closeButton: closeButton
  }, props), content), _objectSpread2(_objectSpread2({
    type: variant === 'loading' ? 'default' : variant
  }, placement && {
    position: placement
  }), options));
};
const update = (id, _ref2, props) => {
  let {
      content,
      closeButton,
      placement,
      title,
      variant = 'info'
    } = _ref2,
    options = _objectWithoutProperties(_ref2, _excluded2);
  toast.update(id, _objectSpread2(_objectSpread2({
    render: _ref3 => {
      let {
        closeToast
      } = _ref3;
      return /*#__PURE__*/React.createElement(Toast, _extends({
        title: title,
        variant: variant,
        closeButton: closeButton,
        closeToast: closeToast
      }, props), content);
    },
    type: variant === 'loading' ? 'default' : variant
  }, placement && {
    position: placement
  }), options));
};
const promise = function (promise, _ref5) {
  let {
    pending,
    success,
    error
  } = _ref5;
  let _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let props = arguments.length > 3 ? arguments[3] : undefined;
  let {
      closeButton,
      placement
    } = _ref4,
    options = _objectWithoutProperties(_ref4, _excluded3);
  toast.promise(promise, {
    pending: _objectSpread2(_objectSpread2({
      render: _ref6 => {
        let {
          closeToast
        } = _ref6;
        return /*#__PURE__*/React.createElement(Toast, _extends({
          closeButton: closeButton,
          title: pending.title,
          variant: "loading",
          closeToast: closeToast
        }, props), pending.content);
      },
      type: 'default'
    }, placement && {
      position: placement
    }), options),
    success: _objectSpread2(_objectSpread2({
      render: _ref7 => {
        let {
          closeToast
        } = _ref7;
        return /*#__PURE__*/React.createElement(Toast, _extends({
          closeButton: closeButton,
          title: success.title,
          variant: "success",
          closeToast: closeToast
        }, props), success.content);
      },
      type: 'success'
    }, placement && {
      position: placement
    }), options),
    error: _objectSpread2(_objectSpread2({
      render: _ref8 => {
        let {
          closeToast
        } = _ref8;
        return /*#__PURE__*/React.createElement(Toast, _extends({
          closeButton: closeButton,
          title: error.title,
          variant: "error",
          closeToast: closeToast
        }, props), error.content);
      },
      type: 'error'
    }, placement && {
      position: placement
    }), options)
  });
};
const useToast = () => {
  return {
    notify: notify,
    clearWaitingQueue: toast.clearWaitingQueue,
    dismiss: toast.dismiss,
    done: toast.done,
    error: (options, props) => {
      return notify(_objectSpread2({
        variant: 'error'
      }, options), props);
    },
    info: (options, props) => {
      return notify(_objectSpread2({
        variant: 'info'
      }, options), props);
    },
    isActive: toast.isActive,
    loading: (options, props) => {
      return notify(_objectSpread2({
        variant: 'loading'
      }, options), props);
    },
    promise: promise,
    success: (options, props) => {
      return notify(_objectSpread2({
        variant: 'success'
      }, options), props);
    },
    update: update,
    warning: (options, props) => {
      return notify(_objectSpread2({
        variant: 'warning'
      }, options), props);
    }
  };
};

const TooltipContext = /*#__PURE__*/React.createContext(null);

/**
 * Context props.
 */

/**
 * Component variant.
 */
const TooltipPlacement = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
  'top-start': 'top-start',
  'top-end': 'top-end',
  'right-start': 'right-start',
  'right-end': 'right-end',
  'bottom-start': 'bottom-start',
  'bottom-end': 'bottom-end',
  'left-start': 'left-start',
  'left-end': 'left-end'
};

/**
 * Component props.
 */

/**
 * Component style.
 */
const StyledTooltipContent = styled.div`
  ${baseContainer}

  align-items: center;
  background-color: var(--redsift-color-neutral-white);
  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  color: var(--redsift-color-neutral-black);
  display: flex;
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  font-family: var(--redsift-typography-tooltip-font-family);
  font-size: var(--redsift-typography-tooltip-font-size);
  font-weight: var(--redsift-typography-tooltip-font-weight);
  line-height: var(--redsift-typography-tooltip-line-height);
  max-width: calc(100vw - 48px);
  padding: 4px 8px;
  z-index: var(--redsift-layout-z-index-tooltip);

  .redsift-tooltip-content__arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: var(--redsift-color-neutral-white);
    border-style: solid;
  }

  ${_ref => {
  let {
    $placement
  } = _ref;
  switch ($placement) {
    case TooltipPlacement.left:
    case TooltipPlacement['left-end']:
    case TooltipPlacement['left-start']:
      return css`
          .redsift-tooltip-content__arrow {
            border-width: 6px 0 6px 6px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
        `;
    case TooltipPlacement.top:
    case TooltipPlacement['top-end']:
    case TooltipPlacement['top-start']:
      return css`
          .redsift-tooltip-content__arrow {
            border-width: 6px 6px 0;
            border-right-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `;
    case TooltipPlacement.right:
    case TooltipPlacement['right-end']:
    case TooltipPlacement['right-start']:
      return css`
          .redsift-tooltip-content__arrow {
            border-width: 6px 6px 6px 0;
            border-top-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `;
    case TooltipPlacement.bottom:
    case TooltipPlacement['bottom-end']:
    case TooltipPlacement['bottom-start']:
    default:
      return css`
          .redsift-tooltip-content__arrow {
            border-width: 0 6px 6px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-left-color: transparent;
          }
        `;
  }
}}
`;

const COMPONENT_NAME$2 = 'TooltipContent';
const CLASSNAME$2 = 'redsift-tooltip-content';
const DEFAULT_PROPS$2 = {};

/**
 * The TooltipContent component.
 */
const TooltipContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    className,
    style
  } = props;
  const {
    getFloatingProps,
    isOpen,
    placement,
    refs,
    strategy,
    x,
    y,
    middlewareData: {
      arrow: {
        x: arrowX,
        y: arrowY
      } = {}
    }
  } = useTooltipContext();
  const popoverRef = useMergeRefs([refs.setFloating, ref]);
  const {
    arrowRef
  } = useTooltipContext();
  const staticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
  }[placement.split('-')[0]];
  return /*#__PURE__*/React.createElement(FloatingPortal, {
    id: "redsift-app-container"
  }, isOpen && /*#__PURE__*/React.createElement(StyledTooltipContent, _extends({
    className: classNames(TooltipContent.className, className),
    ref: popoverRef,
    style: _objectSpread2({
      position: strategy,
      top: y !== null && y !== void 0 ? y : 0,
      left: x !== null && x !== void 0 ? x : 0,
      visibility: x == null ? 'hidden' : 'visible'
    }, style)
  }, getFloatingProps(props), {
    $placement: placement
  }), /*#__PURE__*/React.createElement("div", {
    ref: arrowRef,
    className: `${TooltipContent.className}__arrow`,
    style: {
      left: arrowX != null ? `${arrowX}px` : '',
      top: arrowY != null ? `${arrowY}px` : '',
      [staticSide]: '-6px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: `${TooltipContent.className}__inner`
  }, children)));
});
TooltipContent.className = CLASSNAME$2;
TooltipContent.defaultProps = DEFAULT_PROPS$2;
TooltipContent.displayName = COMPONENT_NAME$2;

const COMPONENT_NAME$1 = 'TooltipTrigger';
const CLASSNAME$1 = 'redsift-tooltip-trigger';
const DEFAULT_PROPS$1 = {};

/**
 * The TooltipTrigger component.
 */
const TooltipTrigger = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children
  } = props;
  const {
    getReferenceProps,
    refs,
    tooltipId
  } = useTooltipContext();
  const childrenRef = children.ref;
  const triggerRef = useMergeRefs([refs.setReference, ref, childrenRef]);
  if ( /*#__PURE__*/React.isValidElement(children)) {
    var _children$props$child;
    return /*#__PURE__*/React.cloneElement(children, _objectSpread2({}, getReferenceProps(_objectSpread2(_objectSpread2(_objectSpread2({
      ref: triggerRef
    }, props), {}, {
      'aria-describedby': tooltipId
    }, children.props), {}, {
      children: (_children$props$child = children.props.children) !== null && _children$props$child !== void 0 ? _children$props$child : ''
    }))));
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    ref: triggerRef
  }, getReferenceProps(props)), children);
});
TooltipTrigger.className = CLASSNAME$1;
TooltipTrigger.defaultProps = DEFAULT_PROPS$1;
TooltipTrigger.displayName = COMPONENT_NAME$1;

function useTooltip(_ref) {
  let {
    defaultOpen,
    delay,
    placement,
    isOpen: propsIsOpen,
    onOpen,
    tooltipId: propsTooltipId
  } = _ref;
  const arrowRef = useRef(null);
  const [isOpen, setIsOpen] = useState(propsIsOpen !== null && propsIsOpen !== void 0 ? propsIsOpen : defaultOpen);
  const [_id] = useId();
  const tooltipId = propsTooltipId !== null && propsTooltipId !== void 0 ? propsTooltipId : _id;
  useEffect(() => {
    setIsOpen(propsIsOpen !== null && propsIsOpen !== void 0 ? propsIsOpen : defaultOpen);
  }, [propsIsOpen, defaultOpen]);
  const handleOpen = useCallback(collapsed => {
    if (onOpen) {
      onOpen(collapsed);
    }
    if (propsIsOpen === undefined || propsIsOpen === null) {
      setIsOpen(collapsed);
    }
  }, [onOpen]);
  const data = useFloating({
    placement,
    open: isOpen,
    onOpenChange: handleOpen,
    whileElementsMounted: autoUpdate,
    middleware: [offset(8), flip({
      fallbackAxisSideDirection: 'start'
    }), shift({
      padding: 8
    }), arrow({
      element: arrowRef
    })]
  });
  const context = data.context;
  const hover = useHover(context, {
    move: false,
    delay: {
      open: delay,
      close: 0
    },
    handleClose: safePolygon()
  });
  const focus = useFocus(context);
  const dismiss = useDismiss(context);
  const role = useRole(context, {
    role: 'tooltip'
  });
  const interactions = useInteractions([hover, focus, dismiss, role]);
  return React.useMemo(() => _objectSpread2(_objectSpread2(_objectSpread2({
    isOpen,
    handleOpen
  }, interactions), data), {}, {
    arrowRef,
    tooltipId
  }), [isOpen, handleOpen, interactions, data, arrowRef, tooltipId]);
}

const COMPONENT_NAME = 'Tooltip';
const CLASSNAME = 'redsift-tooltip';
const DEFAULT_PROPS = {
  delay: 500,
  placement: TooltipPlacement.top
};

/**
 * The Tooltip component.
 */
const BaseTooltip = props => {
  const {
    children,
    defaultOpen,
    delay,
    isOpen,
    onOpen,
    placement,
    tooltipId
  } = props;
  const tooltip = useTooltip({
    defaultOpen,
    delay,
    placement,
    isOpen,
    onOpen,
    tooltipId
  });
  const [[trigger], [content]] = partitionComponents(React.Children.toArray(children), [isComponent('TooltipTrigger'), isComponent('TooltipContent')]);
  return /*#__PURE__*/React.createElement(TooltipContext.Provider, {
    value: tooltip
  }, trigger, content);
};
BaseTooltip.className = CLASSNAME;
BaseTooltip.defaultProps = DEFAULT_PROPS;
BaseTooltip.displayName = COMPONENT_NAME;
const Tooltip = Object.assign(BaseTooltip, {
  Trigger: TooltipTrigger,
  Content: TooltipContent
});

const useTooltipContext = () => {
  const context = React.useContext(TooltipContext);
  if (context == null) {
    throw new Error('Tooltip components must be wrapped in <Tooltip />');
  }
  return context;
};

export { BaseDialog, BaseDialogContent, BasePopover, BaseTooltip, Dialog, DialogContent, DialogContentActions, DialogContentBody, DialogContentHeader, DialogContext, DialogSize, DialogTrigger, Popover, PopoverContent, PopoverContext, PopoverPlacement, PopoverTrigger, StyledPopoverContent, Toast, ToastContainer, ToastPlacement, ToastVariant, Tooltip, TooltipContent, TooltipContext, TooltipPlacement, TooltipTrigger, sizeToDimension, useDialog, useDialogContext, usePopover, usePopoverContext, useToast, useTooltip, useTooltipContext };
//# sourceMappingURL=index.js.map
